import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {
  FilterWithType, LangService,
  LoaderService,
  NavigateService,
  TableComponent,
  TableConfig,
  TableDataTransformer,
  TopButton
} from 'ngx-satoris';
import {Place} from 'src/app/shared/models/place';
import {ApiService} from '../../shared/services/api.service';
import {PlacesService} from '../../shared/services/places.service';
import {TABLE_PLACES_CONFIG, ORIGINAL_TABLE_PLACES_CONFIG, TablePlacesEnum, TablePlacesFilterEnum} from './table-config';
import {PaginationQuery, SortQuery} from 'ngx-satoris/lib/shared/models/params';

@Component({
  selector: 'app-places',
  templateUrl: './places.component.html',
  styleUrls: ['./places.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PlacesComponent implements OnInit {
  tableId: string = 'table-places';
  config: TableConfig = {...TABLE_PLACES_CONFIG};
  readonly initialConfig: TableConfig = {...ORIGINAL_TABLE_PLACES_CONFIG};
  tableDataTransformer: TableDataTransformer<Place>;

  totalCount: number;

  topButtons: TopButton[] = [{label: this.lang.transform('create_place.title'), icon: 'add', action: () => this.nav.to('place/new')}];

  constructor(public nav: NavigateService,
    public api: ApiService,
    private placesService: PlacesService,
    private lang: LangService,
    private loader: LoaderService) {}

    @ViewChild('smartTable') smartTable: TableComponent;

    ngOnInit() {
      this.setupTableDataTransformer();
    }

    setupTableDataTransformer(): void {
      this.tableDataTransformer = {
        transformData: (placeData: Place) => ({
          [TablePlacesEnum.ID]: {value: placeData.id || ''},
          [TablePlacesEnum.NAME]: {value: placeData.longName || ''}
        })
      };
      const tableConfig = JSON.parse(JSON.stringify(TABLE_PLACES_CONFIG));
      tableConfig.dataTransformer = this.tableDataTransformer;
      tableConfig.storagePrefix = this.api.userInfo.id+'';
      this.config = tableConfig;
    }

    onQueryChange(e: {filters: FilterWithType[]; sort: SortQuery; pagination: PaginationQuery}): void {
      if(!e.pagination.isPreload) {
        this.loader.loading(true);
      }
      const queryParams: any = {};
      e.filters?.forEach(filter => {
        if(filter.serverFilter && filter.value) {
          switch(filter.filterId) {
          case TablePlacesFilterEnum.ID:
            queryParams.search = filter.value;
            break;
          case TablePlacesFilterEnum.NAME:
            queryParams.search = filter.value;
            break;
          }
        }
      });

      this.placesService.getAllPlaces(e.pagination.offset, e.pagination.limit, queryParams.search).then((res) => {
        this.totalCount = res.count;
        if(this.tableDataTransformer) {
          this.smartTable.updateTableData(res.result, e.pagination.isPreload, e.pagination.offset);
        }
        this.loader.loading(false);
      });
    }

    onLoadingStateChange(state: {navigateToPreloadingPage: boolean, dataReady: boolean}): void {
      if(state.navigateToPreloadingPage) this.loader.loading(true);
      if(state.dataReady) this.loader.loading(false);
    }

    navigateTo(placeId: number): void {
      this.nav.to(`place/${placeId}`);
    }
}
